module.exports = __webpack_public_path__ + "img/icon-care.e9674653.png";